import axios from '../api/index.js';

//查询新闻中心列表
export let getNewsList = (params) => {
    return axios.post(`/client/dynamic/info/list`,params);
};

//查询新闻中心详情
export let getNewsContent = (params) => {
    return axios.get(`/client/dynamic/info/${params}`);
};



// WEBPACK FOOTER //
// ./src/api/news.js